var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex justify-content-center align-items-center" },
    [
      _c(
        "div",
        [
          _c(
            "b-button",
            {
              staticClass: "btn-icon rounded-circle p-3",
              attrs: {
                variant: "secondary",
                size: "sm",
                "data-cy": "see-events"
              },
              on: {
                click: function($event) {
                  return _vm.seeEvents()
                }
              }
            },
            [_c("feather-icon", { attrs: { icon: "SearchIcon" } })],
            1
          )
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "modal-see-events-" + _vm.item.id,
          attrs: {
            id: "modal-see-events-" + _vm.item.id,
            title: "Eventos del email",
            "no-close-on-backdrop": "",
            size: "lg",
            "hide-footer": ""
          }
        },
        [
          _c(
            "b-overlay",
            { attrs: { show: _vm.loadingEventos } },
            _vm._l(_vm.eventos, function(evento) {
              return _c(
                "div",
                {
                  key: evento.timestamp,
                  staticClass: "row border-top",
                  staticStyle: { padding: "10px" }
                },
                [
                  _c("div", { staticClass: "col-2" }, [
                    _vm._v(" " + _vm._s(evento.type) + " ")
                  ]),
                  _c("div", { staticClass: "col-4" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("dateFormatDateTimeLocal")(evento.timestamp)
                        ) +
                        " "
                    )
                  ]),
                  evento.event && evento.event.ipAddress
                    ? _c(
                        "div",
                        { staticClass: "col-3" },
                        [
                          _c(
                            "vs-chip",
                            [
                              _c("vs-avatar", {
                                attrs: { icon: "place", color: "green" }
                              }),
                              _vm._v(" " + _vm._s(evento.event.ipAddress) + " ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  evento.event && evento.event.delayType
                    ? _c(
                        "div",
                        { staticClass: "col-3" },
                        [
                          _c(
                            "vs-chip",
                            [
                              _c("vs-avatar", {
                                attrs: { icon: "schedule", color: "red" }
                              }),
                              _vm._v(" " + _vm._s(evento.event.delayType) + " ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  evento.event && evento.event.expirationTime
                    ? _c(
                        "div",
                        { staticClass: "col-3" },
                        [
                          _c(
                            "vs-chip",
                            [
                              _c("vs-avatar", {
                                attrs: { icon: "schedule", color: "red" }
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("dateFormatDateTime")(
                                      evento.event.expirationTime
                                    )
                                  ) +
                                  " "
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  evento.event && evento.event.delayedRecipients
                    ? _c(
                        "div",
                        _vm._l(evento.event.delayedRecipients, function(
                          destinatario
                        ) {
                          return _c(
                            "div",
                            {
                              key: destinatario.emailAddress,
                              staticClass: "col-4"
                            },
                            [
                              _c(
                                "vs-chip",
                                [
                                  _c("vs-avatar", { attrs: { icon: "email" } }),
                                  _vm._v(
                                    " " +
                                      _vm._s(destinatario.emailAddress) +
                                      " "
                                  )
                                ],
                                1
                              ),
                              _vm._v(
                                " " + _vm._s(destinatario.diagnosticCode) + " "
                              )
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  evento.event && evento.event.userAgent
                    ? _c("div", { staticClass: "col-12" }, [
                        _c("p", { staticClass: "text-archive" }, [
                          _vm._v(" " + _vm._s(evento.event.userAgent) + " ")
                        ])
                      ])
                    : _vm._e(),
                  evento.event && evento.event.recipients
                    ? _c(
                        "div",
                        { staticClass: "col-12" },
                        _vm._l(evento.event.recipients, function(destinatario) {
                          return _c(
                            "vs-chip",
                            { key: destinatario },
                            [
                              _c("vs-avatar", { attrs: { icon: "email" } }),
                              _vm._v(" " + _vm._s(destinatario) + " ")
                            ],
                            1
                          )
                        }),
                        1
                      )
                    : _vm._e()
                ]
              )
            }),
            0
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }